<template>
	<div class="equipment-picker">

		<!--
			<h2 v-if="typeSelected">{{ typeSelected.name }}</h2>
			<h2 v-else-if="categorySelected">{{categorySelected.name}}</h2>
			<h2 v-else>Equipment</h2>
		-->

		<ol v-if="!equipmentSelected && (categorySelected || allowedTypeIds)" class="breadcrumb">

			<li class="breadcrumb-item"><a href="#"><i class="fa fa-arrow-up" v-on:click="upLevel"></i></a></li>

			<li v-if="!allowedTypeIds" class="breadcrumb-item">
				<a href="#" v-on:click.prevent="deselectCat">
					Categories
				</a>
			</li>
			<li v-else class="breadcrumb-item">
				<a href="#" v-on:click.prevent="deselectType">
					Types
				</a>
			</li>

			<template v-if="categorySelected && !allowedTypeIds">
				<li v-if="!typeSelected" class="breadcrumb-item">
					{{categorySelected.name}}
				</li>
				<li v-else class="breadcrumb-item">
					<a href="#" v-on:click.prevent="deselectType">
					{{categorySelected.name}}
					</a>
				</li>
			</template>

			<template v-if="typeSelected">
				<li class="breadcrumb-item">
					{{typeSelected.name}}
				</li>
			</template>
		</ol>

		<div v-if="!categorySelected && !allowedTypeIds" class="list-group">
			<button v-for="cat in categories" 
				class="list-group-item list-group-item-action"
				type="button" 
				:key="cat.id+'_'+cat.name"
				v-on:click="selectCat(cat)">
				<i v-if="cat.color_hex" class="fa fa-circle mr-1" :style="{color:cat.color_hex}"></i>
				{{cat.name}}
			</button>
		</div>
		<div v-else-if="!typeSelected">
			<div class="list-group">
				<button v-for="type in equipmentTypes" 
					class="list-group-item list-group-item-action"
					type="button" 
					:key="type.name"
					v-on:click="selectType(type)">
					<div class="d-flex flex-row justify-content-between align-items-center">
						<div>
							<i v-if="type.color_hex" class="fa fa-circle mr-1" :style="{color:type.color_hex}"></i>
							{{type.name}}
						</div>
						<template v-if="!hideMeta">
							<div>
								<template v-if="type.cost_per_hour">
									<span class='text-muted'>Cost/Hr:</span> ${{ parseFloat(type.cost_per_hour).toFixed(2) }}
								</template>
							</div>
							<div>
								<template v-if="compileBilledAtRates(type)">
									<span class='text-muted'>Billed at:</span> <!--${{ parseFloat(type.charge_out_rate).toFixed(2) }}{{type.charge_out_rate_unit ? unitToUnitRate(type.charge_out_rate_unit) : '/hr'}}-->
									{{ compileBilledAtRates(type) }}
								</template>
							</div>
						</template>
					</div>
				</button>
			</div>
			<p v-if="equipmentTypes.length == 0">No types found in <strong>{{ categorySelected.name }}</strong></p>
		</div>
		<div v-else-if="!equipmentSelected">
			
			<draggable v-if="isDraggable"
				class="list-group mt-2" 
				:value="mutatedEquipmentList" 
				:group="draggableGroup"
				v-on:start="$emit('start')"
				v-on:choose="$emit('dragChoose')"
				v-on:unchoose="$emit('dragUnchoose')">

				<div v-for="equipment in mutatedEquipmentList" 
					class="list-group-item list-group-item-action">
					
					<equipment-tile-template
						:hide-meta="hideMeta"
						:equipment="equipment"
						:type-selected="typeSelected"
						:include-archived="includeArchived">
					</equipment-tile-template>

					<i class="fa fa-plus icon-button" v-on:click="addClick(equipment)"></i>
					
				</div>
			</draggable>
			<div v-else class="list-group mt-2">
				<button v-for="equipment in mutatedEquipmentList" 
					type="button" 
					class="list-group-item list-group-item-action"
					v-on:click="selectEquipment(equipment)">
					
					<equipment-tile-template
						:hide-meta="hideMeta"
						:equipment="equipment"
						:type-selected="typeSelected"
						:include-archived="includeArchived">
					</equipment-tile-template>

				</button>
				<p v-if="mutatedEquipmentList.length == 0">No equipment items in <strong>{{ typeSelected.name }}</strong> type.</p>
			</div>
		</div>
		<div v-else v-on:click="equipmentSelected = false" class="selected-label">
			<div class="d-flex flex-row">

				<field :readonly="true"  :value="equipmentSelected.description"></field>
	
				<button class="ml-2 btn btn-light btn-sm" type="button"><i class="fa fa-ellipsis-h"></i></button>
			</div>
		</div>
	</div>
</template>
<script type="text/javascript">
import Field from "../Field"

import EquipmentTileTemplate from "@/components/equipment_picker/EquipmentTileTemplate"

import draggable from "vuedraggable"

export default {
	name: "EquipmentPicker",
	components: {
		Field,
		EquipmentTileTemplate,
		draggable
	},
	props: [
		"value",
		"allowedTypeIds", //array of ids
		"hideMeta", //boolean
		"isDraggable", //boolean
		"draggableGroup", //array
		"attachedData", //array of equipment items with keys containing additional data
		"includeArchived"
	],
	data() {
		return {
			equipmentList: [],
			categories: [],
			equipmentTypes: [],
			categorySelected: false,
			typeSelected: false,
			equipmentSelected: false
		}
	},
	watch: {
		value() {
			this.setFromValue()
		},
		includeArchived() {
			this.setFromValue()
		}
	},
	computed: {
		mutatedEquipmentList() {
			let vm = this

			return this.equipmentList.map(eq => {
				eq.attachedData = ""

				if (vm.attachedData) {
					let eqFromAttached = vm.attachedData.find(attachedEq => attachedEq.id == eq.id)

					if (eqFromAttached) 
						eq.attachedData = eqFromAttached.attachedData
				}

				return eq
			})
		}
	},
	methods: {
		unitToUnitRate(unit) {
			//converts unit (days) to /day
			return "/"+unit.substring(0,unit.length - 1)
		},
		setFromValue() {
			let vm = this

			if (!this.value) {
				this.typeSelected = false
				this.equipmentSelected = false
			}
			else if (typeof this.value == 'string' && isNaN(this.value)) {
				//this is a slug being passed in, set the object
				let segments = this.segmentUrl(this.value)

				let cat = this.categories.find(cat => cat.name.trim().slugify() == segments[0])

				this.selectCat(cat).then(response => {
					if (segments.length > 1) {

						let type = vm.equipmentTypes.find(type => type.name.trim().slugify() == segments[1])

						vm.selectType(type)
					}
				})
			}
			else if (typeof +this.value == 'number') {
				//this is the equipment id
				this.getJSON("Equipment/find/"+this.value).then(response => {
					if (response.success) {
						vm.equipmentSelected = response.data
						vm.getJSON("EquipmentType/find/"+vm.equipmentSelected.type_id).then(response => {
							if (response.success) {
								vm.typeSelected = response.data

								vm.getJSON("EquipmentCategory/find/"+vm.typeSelected.category_id).then(response => {
									if (response.success)
										vm.categorySelected = response.data
								})
							}
						})
					}
				})
			}
		},
		upLevel() {
			if (this.typeSelected)
				this.deselectType()
			else if (this.categorySelected)
				this.deselectCat()
		},
		compileBilledAtRates(type) {
			let ratesString = "", multiRates = false
			try {
				multiRates = JSON.parse(type.charge_out_rates_json)

				let ratesCnt = 0
				Object.keys(multiRates).forEach(rateTypeKey => {
					if (multiRates[rateTypeKey].enabled) {
						if (ratesCnt != 0)
							ratesString += ", "

						
						ratesString += "$ " + parseFloat(multiRates[rateTypeKey].rate).toFixed(2)
						ratesString += "/" + rateTypeKey

						ratesCnt++
					}
				})
			}
			catch (e) {}

			if (!multiRates) {
				ratesString = "$ " + parseFloat(type.charge_out_rate).toFixed(2)
				ratesString += type.charge_out_rate_unit ? this.unitToUnitRate(type.charge_out_rate_unit) : '/hr'
			}

			return ratesString
		},
		reselect() {
			this.equipmentSelected = false
			this.typeSelected = false
		},
		selectCat(cat) {
			let vm = this
			
			return new Promise((resolve,reject) => {
				if (cat) {
					vm.categorySelected = cat

					vm.$emit("selectEvent",{event: "categorySelected", obj: cat})
					vm.fetchTypes(cat.id).then(response => {
						resolve(response)
					})
				}
				else
					resolve(null)
			})
		},
		selectType(type) {
			this.typeSelected = type

			this.$emit('selectEvent',{event: "typeSelected", obj: type})
			this.fetchEquipmentFiltered(type.id)
		},
		deselectCat() {
			this.categorySelected = false
			this.typeSelected = false
			this.$emit('selectEvent',{event: "categoryDeselected"})
			this.$emit("catDeselected",{event: "categoryDeselected"})
		},
		deselectType() {
			this.typeSelected = false
			this.$emit('selectEvent',{event: "typeDeselected"})
			this.$emit("typeDeselected",{event: "typeDeselected"})
		},
		addClick(eq) {
			this.$emit("addClick",eq)
		},
		selectEquipment(eq) {
			let vm = this

			this.equipmentSelected = eq

			this.$emit("input",eq.id)
			this.$emit("equipmentChange",this.equipmentSelected)
		},
		fetchEquipmentFiltered(type_id) {
			let vm = this

			return new Promise((resolve,reject) => {

				let params = {
					filters: [
						["type_id",type_id],
					]
				}

				if (!vm.includeArchived)
					params.filters.push(["archived",0])

				vm.spinner(true)

				vm.getJSON("Equipment/get",params,true).then(response => {
					vm.spinner(false)

					if (response.success) {
						vm.equipmentList = response.data
						vm.$emit("equipmentSet",response.data)
					}

					resolve(response)
				})
			
			})
		},
		fetchTypes(cat_id) {
			let vm = this

			this.spinner(true)

			let filters = []
			if (cat_id) {
				filters = [
					["category_id",cat_id]
				]
			}
			else if (this.allowedTypeIds) {
				filters = [
					["id",this.allowedTypeIds]
				]
			}

			return new Promise((resolve,reject) => {
				let params = {filters}

				vm.getJSON("EquipmentType/get",params,true).then(response => {
					vm.spinner(false)

					if (response.success){
						vm.equipmentTypes = response.data
						vm.$emit("typesSet",response.data)
					}
					
					resolve(response)
				})

			})
		},
		fetchCategories() {
			let vm = this

			this.spinner(false)

			return new Promise((resolve,reject) => {

				vm.getJSON("EquipmentCategory/get",{},true).then(response => {
					vm.spinner(false)

					if (response.success) {
						vm.categories = response.data
						vm.$emit("categoriesSet",response.data)
					}

					resolve(response)
				})
			})
		}
	},
	created() {
		if (this.allowedTypeIds)
			this.fetchTypes()
		else
			this.fetchCategories()

		this.setFromValue()
	}
}
</script>

<style type="text/css">
	.list-group button {
		cursor: pointer;
	}

	.equipment-picker {
		margin-bottom: 10px;
	}
</style>